
import React from "react";
import { EvolucionSection } from "./sections/EvolucionSection";
import { PosicionamientoSection } from "./sections/PosicionamientoSection";
import { GeoPositioningSection } from "./sections/GeoPositioningSection";
import { EstrategiasSection } from "./sections/EstrategiasSection";
import { TendenciasSection } from "./sections/TendenciasSection";
import { HerramientasSection } from "./sections/HerramientasSection";

export function ArticleContent() {
  return (
    <div className="prose prose-lg prose-invert max-w-none">
      <EvolucionSection />
      <PosicionamientoSection />
      <GeoPositioningSection />
      <EstrategiasSection />
      <TendenciasSection />
      <HerramientasSection />
    </div>
  );
}
